import { takeEvery } from 'redux-saga/effects';
import { SET_GDPR, SET_COUNTRY_CODE } from './actions';
import { onSetGDPR, onSetCountryCode } from './effects';

export function* setGDPRSaga() {
  yield takeEvery(SET_GDPR, onSetGDPR);
}

export function* setCountryCodeSaga() {
  yield takeEvery(SET_COUNTRY_CODE, onSetCountryCode);
}
